import React from 'react'
import { filter } from '../../common/svg'
import SecureImage from "../../components/BucketImage/Image";
const Filter = () => {
  return (
      <button className='border border-[#EAEAEA] rounded-[20px] w-[120px] flex items-center justify-center'>
        <div className='flex items-center gap-2'>
            {/* <img src={filter} alt='filter' /> */}
            <SecureImage
                        
                        fileKey={ filter}
                        alt="header icon"
                        width="20px"
                      />
            <p>Filters</p>
        </div>
      </button>
  )
}

export default Filter
